import { InputAdornment } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledInputAdornment = styled(InputAdornment)(
  ({ position, theme }) => ({
    color: theme.palette.custom.black[40],

    ...(position === 'start' && { marginRight: '10px' }),
  })
);
